import React from 'react';
import {
	Alert,
	Autocomplete,
	Button,
	Grid,
	IconButton,
	Step,
	StepContent,
	StepLabel,
	Stepper,
	TextareaAutosize,
	TextField,
	Tooltip,
	Typography,
} from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { HeaderSection, setColorStyle } from './BiasInfo';
import {
	columnStyle,
	getFullName,
	handleInfo,
	justCentered,
	orderAreas,
	rowStyle,
} from '../../../helpers/utils';
import { useState } from 'react';
import { ProcessForm } from './ProcessForm';
import { sendWhatsApp, template1 } from '../../../helpers/whatsappApi';
import { useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { ANNOTATION_TYPES } from '../../utils/lists';
import { registerAnnotation } from '../../../actions/annotation';
import { useEffect } from 'react';
import { getProcesses } from '../../../actions/process';
import {
	diffDays,
	formatDateMX,
	formatDateTimeMX,
	gringoFormat,
} from '../../../helpers/hours';
import { registerEvent } from '../../../actions/event';

const TextFieldComponent = (params, label) => (
	<TextField
		fullWidth
		required
		margin='normal'
		{...params}
		label={label}
		variant='standard'
	/>
);

// SUBBIAS INFORMATION DETAIL
export const SubbiasInfoDetailColumn = ({
	order = null,
	subbias = null,
	bias = null,
	individualAreas = null,
	setCurrentSubbias = null,
	refreshBias = null,
}) => {
	// States
	const [fullHistoryView, setFullHistoryView] = useState(false);
	const [isProcessForm, setIsProcessForm] = useState(false);

	// Selected process
	const [selectedProcess, setSelectedProcess] = useState(null);

	// History list
	const [historyList, setHistoryList] = useState([]);

	// Store
	const { user } = useSelector((state) => state);
	const { biases: subbiasesStore = [] } = useSelector(
		(state) => state.biases
	);

	const handleRefreshCurrentSubbias = (data = false) => {
		setCurrentSubbias((currentSubbias) => ({
			...currentSubbias,
			updatedLocally: Date.now(),
			newProgresses: data,
		}));
	};

	// Handle get history
	const handleGetHistory = (reset = false) => {
		if (subbias && !reset) {
			if (!subbias?.newProgresses) {
				if (subbias?.id) {
					getProcesses(subbias?.id, bias?.id).then(
						async ({ data }) => {
							const newAreas = data.results.map((process) => {
								const diffDaysOrder = diffDays(
									formatDateMX(process.entry_date),
									formatDateMX(process.final_date)
								);

								const isDelayed = (diff, allowed) => {
									if (diff !== null) {
										return diff > allowed;
									}
									return false;
								};

								const authorized_days = process.area.days;

								return {
									original: {
										...process,
										bias: process.bias,
										subbias: process.subbias.id,
										area: process.area.id,
										created_by: process.created_by.id,
									},
									name: process.area.name,
									active: true,
									is_delayed: isDelayed(
										diffDaysOrder,
										authorized_days
									),
									occupied_days: diffDaysOrder,
									authorized_days: authorized_days,
									entry_date: formatDateMX(
										process.entry_date
									),
									final_date: formatDateMX(
										process.final_date
									),
									entry_date_original: process?.entry_date
										? gringoFormat(process?.entry_date)
										: null,
									final_date_original: process?.final_date
										? gringoFormat(process?.final_date)
										: null,
									updated_at: formatDateTimeMX(
										process.updated_at
									),
								};
							});
							const orderedAreas = orderAreas(
								newAreas,
								individualAreas
							);
							setHistoryList(orderedAreas);
						}
					);
				}
			} else {
				setHistoryList([]);
			}
		} else {
			setHistoryList([]);
		}
	};

	useEffect(() => {
		handleGetHistory();
	}, [subbias, individualAreas]);

	return (
		<Grid
			item
			xs={4}
			style={{
				...setColorStyle('green'),
				height: '100%',
			}}
		>
			<Grid
				container
				style={{
					...setColorStyle('red'),
					height: '100%',
				}}
			>
				<Grid
					item
					xs={12}
					style={{
						...setColorStyle('blue'),
						padding: '15px',
					}}
				>
					{(isProcessForm && subbias) ||
					selectedProcess !== null ||
					subbiasesStore.length > 0 ? (
						<>
							{/* Progress form */}
							<ProcessForm
								subbiasId={subbias?.id}
								currentBias={bias}
								biasId={subbias?.bias}
								setIsProcessForm={setIsProcessForm}
								areas={historyList}
								refresh={handleGetHistory}
								refreshBias={refreshBias}
								refreshSubbias={handleRefreshCurrentSubbias}
								setCurrentSubbias={setCurrentSubbias}
								selectedProcess={selectedProcess}
								setSelectedProcess={setSelectedProcess}
							/>
						</>
					) : (
						<>
							{/* Timeline */}
							<HistoryTimeLine
								historyList={historyList}
								fullHistoryView={fullHistoryView}
								setFullHistoryView={setFullHistoryView}
								setIsProcessForm={setIsProcessForm}
								subbias={subbias}
								user={user}
								setSelectedProcess={setSelectedProcess}
							/>
						</>
					)}

					<hr />

					{/* Annotations */}
					{/* If there aren't selected subbbiases then show it */}
					{subbiasesStore?.length === 0 && (
						<>
							{!fullHistoryView && subbias !== null && (
								<AnnotationsSection
									order={order}
									subbias={subbias}
									refreshSubbias={handleRefreshCurrentSubbias}
								/>
							)}
						</>
					)}
				</Grid>
			</Grid>
		</Grid>
	);
};

const HistoryTimeLine = ({
	historyList = [],
	fullHistoryView = null,
	setFullHistoryView = null,
	setIsProcessForm = null,
	subbias = null,
	user = null,
	setSelectedProcess = null,
}) => (
	<>
		{' '}
		<div style={{ ...justCentered, ...columnStyle }}>
			<HeaderSection
				text={subbias ? 'Recorrido de la talla:' : 'Recorrido'}
			/>

			{subbias && <h5>{subbias.key}</h5>}

			<div
				style={{
					...justCentered,
					...rowStyle,
					justifyContent: 'space-evenly',
					width: '25%',
				}}
			>
				{subbias && historyList.length > 0 && (
					<>
						{/* BUTTON */}
						{/* Admin, Manager and Consultant are not allowed*/}
						{/* Mesa de control and Logistics are not allowed */}
						{/* {![2, 3, 5].includes(user?.user_type?.id) &&
							![1, 3].includes(user?.area?.id) && (
								<Tooltip title='Nuevo progreso'>
									<IconButton
										style={{
											color: '#1976d2',
											// margin: '0 1px 0 0',
										}}
										edge='end'
										aria-label='info'
										onClick={() => setIsProcessForm(true)}
									>
										<AddIcon />
									</IconButton>
								</Tooltip>
							)} */}

						<Tooltip
							title={
								fullHistoryView
									? 'Vista reducida'
									: 'Vista completa'
							}
						>
							<IconButton
								style={{
									color: '#1976d2',
									// margin: '0 1px 0 0',
								}}
								edge='end'
								aria-label='info'
								onClick={() => {
									setFullHistoryView(
										(fullHistoryView) => !fullHistoryView
									);
								}}
							>
								{fullHistoryView ? (
									<FullscreenExitIcon />
								) : (
									<FullscreenIcon />
								)}
							</IconButton>
						</Tooltip>
					</>
				)}
			</div>
		</div>
		<div
			style={{
				margin: `${historyList.length > 0 ? '10' : '100'}px 0`,
				maxHeight:
					historyList.length > 0
						? `${fullHistoryView ? '70' : '34'}vh`
						: '50vh',
				overflow: 'scroll',
				overflowX: 'hidden',
			}}
		>
			{subbias && historyList.length > 0 ? (
				<Stepper orientation='vertical'>
					{historyList.map((area) => {
						const labelProps = {};
						if (area.is_delayed) {
							labelProps.optional = (
								<Typography variant='caption' color='error'>
									Retraso
								</Typography>
							);

							labelProps.error = true;
						}
						return (
							<Step key={area.name} active={area.active}>
								<StepLabel
									onClick={() => {
										if (area.active) {
											if (
												area.entry_date &&
												area.final_date
											) {
												handleInfo(
													'Este proceso ya fue completado'
												);
											} else {
												setSelectedProcess(area);
											}
										}
									}}
									style={{
										cursor: area.active
											? 'pointer'
											: 'default',
									}}
									{...labelProps}
								>
									{area.name}
								</StepLabel>
								{area.is_delayed !== null && (
									<StepContent>
										<small>
											<b>Entrada:</b> {area.entry_date}{' '}
											<b>→</b> <b>Salida:</b>{' '}
											{area.final_date
												? area.final_date
												: 'No definida aún'}
											<br />
											<b>Días autorizados:</b>{' '}
											{area.authorized_days}
											<br />
											<b>Días ocupados:</b>{' '}
											{area?.occupied_days || '-'}
											<br />
											<b>Última actualización:</b>{' '}
											{area.updated_at}
										</small>
									</StepContent>
								)}
							</Step>
						);
					})}
				</Stepper>
			) : (
				<Alert severity='info'>Selecciona una talla</Alert>
			)}
		</div>
	</>
);

const AnnotationsSection = ({
	order = null,
	subbias = null,
	refreshSubbias = null,
}) => {
	// Annotations form
	const [noteType, setNoteType] = useState(null);
	const [notes, setNotes] = useState('');

	// Message text
	const [msgText, setMsgText] = useState('');

	// States
	const [newError, setNewError] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isMsgSent, setIsMsgSent] = useState(null);

	// Store
	const { user = null } = useSelector((state) => state);
	const { currentBias = null } = useSelector((state) => state.biases);

	// Handle submit notes
	const handleSubmit = async () => {
		// Send problem (whatsapp)
		if (newError) {
			// Prepare data
			const fullName = getFullName(user);
			const area =
				user.area?.name ||
				(user.user_type.id !== 4 ? 'Administrativa' : 'Sin área');
			// Send whatsapp message (template1 = report problem)
			setIsLoading(true);

			sendWhatsApp(
				order,
				user,
				order.contacts,
				template1(fullName, area, order.number_order, notes)
			)
				.then(async ({ data }) => {
					if (currentBias) {
						await registerEvent({
							title: 'Nueva incidencia',
							description: notes,
							type: 'ERR',
							created_by: user.id,
							bias: currentBias?.id,
						});
					}
					setIsMsgSent(true);
					if (data?.ok || data?.msg.includes('sent')) {
						setNotes('');
						setMsgText('Mensaje enviado');

						await registerAnnotation({
							type: 'ALE',
							description: notes,
							created_by: user.id,
							subbias: subbias.id,
						});
						setIsMsgSent(true);
					} else {
						setMsgText(
							'Ocurrió un error al intentar enviar el mensaje. Intenta más tarde'
						);
						setIsMsgSent(false);
					}
					refreshSubbias();
				})
				.catch((error) => {
					console.log(error);
					setMsgText(
						'Ocurrió un error al intentar enviar el mensaje. Intenta más tarde'
					);
					setIsMsgSent(false);
				})
				.finally(() => {
					setIsLoading(false);
					setTimeout(() => {
						setIsMsgSent(null);
						setMsgText('');
					}, 4000);
				});
		} else {
			// Create new annotation
			registerAnnotation({
				type: ANNOTATION_TYPES.find((item) => item.label === noteType)
					.name,
				description: notes,
				created_by: user.id,
				subbias: subbias.id,
			})
				.then(({ data }) => {
					setIsMsgSent(true);
					setNotes('');
					setMsgText('Anotación guardada');
					setIsMsgSent(true);
					refreshSubbias();
				})
				.catch((error) => {
					console.log(error);
					setMsgText(
						'Ocurrió un error al intentar crear la anotación. Intenta más tarde'
					);
					setIsMsgSent(false);
				})
				.finally(() => {
					setIsLoading(false);
					setNoteType(null);
					setTimeout(() => {
						setIsMsgSent(null);
						setMsgText('');
					}, 4000);
				});
		}
	};

	return (
		<>
			{user && (
				<>
					<div style={{ ...justCentered, ...columnStyle }}>
						<HeaderSection
							text={newError ? 'Ayuda' : 'Crear Anotación'}
						/>

						<Button
							size='small'
							variant='text'
							color={newError ? 'primary' : 'error'}
							onClick={() => {
								setNewError(!newError);
							}}
						>
							{newError ? 'Crear anotación' : 'Reportar problema'}
						</Button>
					</div>

					{isMsgSent !== null && msgText.length > 0 && (
						<Alert
							severity={isMsgSent ? 'success' : 'error'}
							style={{ margin: '30px 0 0 0' }}
						>
							{msgText}
						</Alert>
					)}
					{isMsgSent === null && (
						<>
							{!newError && (
								<Autocomplete
									style={{ marginTop: '-15px' }}
									fullWidth
									value={noteType}
									onChange={(_, value) => {
										setNoteType(value);
									}}
									options={[
										'Observación',
										'Compromiso',
										'Estrategia',
									]}
									renderInput={(params) =>
										TextFieldComponent(
											params,
											'Tipo de anotación'
										)
									}
								/>
							)}
							{newError && (
								<small>
									Este mensaje será enviado directamente a los
									administradores
								</small>
							)}
							<TextareaAutosize
								value={notes}
								onChange={({ target }) =>
									setNotes(target.value)
								}
								aria-label='minimum height'
								minRows={5}
								readOnly={noteType === null && !newError}
								disabled={noteType === null && !newError}
								variant='standard'
								placeholder={
									noteType
										? `Escribe aquí tu ${noteType}`
										: newError
										? 'Describe tu problema'
										: 'Selecciona un tipo de anotación'
								}
								style={{
									width: '100%',
									borderRadius: '8px',
									height: 100,
									fontFamily: 'Arial',
									fontSize: '17px',
									marginTop: '10px',
									padding: '10px',
									borderColor: '#E1DEDD',
								}}
							/>
							<LoadingButton
								size='small'
								fullWidth
								disabled={notes.length === 0}
								variant='outlined'
								onClick={handleSubmit}
								loading={isLoading}
							>
								{newError ? 'Enviar' : 'Crear'}
							</LoadingButton>
						</>
					)}
				</>
			)}
		</>
	);
};
